import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import { Nav, Tab, TabContainer, TabContent, TabPane, Tabs, Toast, ToastContainer } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './transcripts.css';
import { getTextureUrl } from '../TwoD/Common/TextureTools';

const TRANSCRIPT_TYPES = {
    action: 1,
    score: 2
};

const TRANSCRIPT_CONFIGURATIONS = [
    null,
    {
        headerClassname: 'transcript-action',
        containerClassName: 'transcript-container-left'  // might change
    },
    {
        headerClassname: 'transcript-score',
        containerClassName: 'transcript-container-right'  // might change
    },
    {
        headerClassname: 'transcript-campaign',
        containerClassName: 'transcript-container-left'
    },
    {
        headerClassname: 'transcript-ai-chatter',
        containerClassName: 'transcript-container-right'
    },
    {
        headerClassname: 'transcript-chat',
        containerClassName: 'transcript-container-right'  // might change
    },
    {
        headerClassname: 'transcript-system',
        containerClassName: 'transcript-container-center'  // might change
    },
    {
        headerClassname: 'transcript-error',
        containerClassName: 'transcript-container-center'  // might change
    }
];


function makeTextureElement(textureId) {
    let src = getTextureUrl(textureId);
    return `<span><img src="${src}" alt="texture-${textureId}" width="50px"/>&nbsp;</span>`;
}


function makeMessage(transcript) {
    let subject = transcript.subject;
    let outcomes = transcript.outcomes;
    let message = '';
    if (subject) {
        message += makeTextureElement(subject);
    }
    outcomes.forEach(textureId => message += makeTextureElement(textureId));
    if (transcript.message) {
        message += transcript.message;
    }
    return message;
}


class ToastEntry extends Component {

    render() {
        if (!this.props.transcript) {
            return <div id={'No Toast'}/>;
        }

        let transcript = this.props.transcript;
        let message = makeMessage(transcript);
        return <>
            <ToastContainer className="p-3" position={'bottom-start'}
                            id={'transcriptToast'}
                            style={{ zIndex: 6 }}
            >
                <Toast show={this.props.showToast}
                       onClose={this.props.closeToast}
                       autohide delay={3000}>
                    <Toast.Header closeButton={true}>
                        <strong className="me-auto">{transcript.game_player && transcript.game_player.name}</strong>
                    </Toast.Header>
                    <Toast.Body>
                        <span dangerouslySetInnerHTML={{ __html: message }}/>
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>;
    }

}


class TranscriptEntry extends Component {


    render() {
        let transcript = this.props.transcript;
        let config = TRANSCRIPT_CONFIGURATIONS[transcript.type];
        let headerClassname = 'transcript-header ' + config.headerClassname;

        let message = makeMessage(transcript);

        let iCreatedIt = transcript.created_by === this.props.userId;
        let myPlayer = transcript.game_player && (
            transcript.game_player.user_id === this.props.userId);
        let toMe = transcript.to_game_player && (
            transcript.to_game_player.user_id === this.props.userId);
        let aboutSomeoneElse = (transcript.game_player && !myPlayer);

        let containerClassName = 'transcript-container-left';
        if (!myPlayer) {
            containerClassName = 'transcript-container-right';
        }

        return (<>
            <div className={containerClassName}>
                <div className={'transcript-card'}>
                    <div className={headerClassname}>
                        {transcript.to_game_player && <div>
                            <div>To: {transcript.to_game_player.name}</div>
                            <div>From: {transcript.game_player && transcript.game_player.name}</div>
                        </div>}
                        {aboutSomeoneElse && <span>
                            {transcript.game_player && transcript.game_player.name}&nbsp;</span>}
                        <small>
                            {moment(transcript.created).format('MM/DD HH:mm:ss')}
                            &nbsp;
                            {moment(transcript.created).fromNow()}
                        </small>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: message }}/>
                </div>
            </div>
            <hr/>
        </>);
    }
}


class LogMessageRow extends Component {
    render() {
        return (<>
            <div>
                <div className={'transcript-card'}>
                    <span dangerouslySetInnerHTML={{ __html: this.props.message }}/>
                </div>
            </div>
            <hr/>
        </>);
    }
}


class TranscriptsModal extends Component {

    render() {
        // my user
        // my gamePlayer
        // my campaignPlayer (must be)

        return <Modal
            show={this.props.showTranscripts}
            onHide={this.props.hide}
            scrollable
            animation
            className={'transcript-modal'}
        >
            <TabContainer
                defaultActiveKey="glyphic"
                id="transcript-tabs"
                className="mb-3"
                justify
            >
                <Modal.Header closeButton
                              style={{ backgroundColor: 'darkcyan'}}>
                    <div style={{width: '100%'}}>
                        <Nav variant="tabs" fill>
                            <Nav.Item>
                                <Nav.Link eventKey="glyphic"
                                          className={'transcript-tab-link'}>
                                    Glyphic</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="logs"
                                          className={'transcript-tab-link'}>
                                    Messages</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Modal.Header>
                <Modal.Body
                    >

                    <TabContent>
                        <TabPane eventKey="glyphic"
                                 title="Glyphic"
                                 id={'glyphic-tab'}
                        >
                            <div className={'transcript-tab-pane-content'}>
                                {this.props.transcripts.map(
                                    (transcript, index) => {
                                        return <TranscriptEntry
                                            key={index}
                                            transcript={transcript}
                                            {...this.props}
                                        />;
                                    })}
                                {this.props.loading &&
                                    <p>Loading from Server</p>}
                                {this.props.transcripts.length === 0 &&
                                    <p>No Transcripts Yet</p>}
                            </div>
                        </TabPane>
                        <TabPane eventKey="logs" title="Messages">
                            <div className={'transcript-tab-pane-content'}>
                                {this.props.logMessages.map(
                                    (message, index) => {
                                        return <LogMessageRow
                                            key={index}
                                            message={message}
                                            {...this.props}
                                        />;
                                    })}
                                {this.props.loading &&
                                    <p>Loading from Server</p>}
                                {this.props.logMessages.length === 0 &&
                                    <p>No Messages Yet</p>}
                            </div>
                        </TabPane>
                    </TabContent>

                </Modal.Body>
                <Modal.Footer
                    style={{ backgroundColor: 'darkcyan' }}>
                    Haunted Space Hotel&trade; - &copy;2022 Fossa Tracks, Inc.
                </Modal.Footer>
            </TabContainer>
        </Modal>;
    }

}

export default class Transcripts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logMessages: [],
            showTranscripts: false,
            transcripts: [],
            loading: false,
            loaded: false,
            userId: this.props.app.state.authenticator.account.user.id,
            packageTranscript: null,
            showToast: false
        };

        this.storedTranscript = {};
        this.props.app.gameController.transcripts = this;

    }

    componentDidMount() {
        this.props.app.gameController.transcripts = this;
    }

    componentWillUnmount() {
        this.props.app.gameController.transcripts = null;
        console.log('transcripts UNMOUNT')
    }

    fetch = () => {
        this.setState({ loading: true });
        let typeName = 'Transcript';
        let packageValue = { type: 'Fetch' };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    };

    receiveMessage = (receivedMessage) => {
        this.setState({ loading: false });
        let packageType = receivedMessage.package.type;
        let packageData = receivedMessage.package.data;
        switch (packageType) {
        case 'List':
            this.setState({
                transcripts: packageData.transcripts,
                loaded: true
            });
            break;
        case 'Message':
            // console.log('message received for toast');
            // todo: change here to "send to toast handler."
            // if (this.state.loaded) {
            let newTranscripts = [ ...this.state.transcripts, packageData.transcript ];
            // newTranscripts.unshift(packageData.transcript);
            this.setState({
                transcripts: newTranscripts,
                packageTranscript: packageData.transcript,
                loaded: true,
                showToast: false  // disable toast
            });
            // } else {
            //     this.setState({
            //         packageTranscript: packageData.transcript,
            //         showToast: true
            //     }, this.fetch);
            // }
            break;
        default:
            break;
        }
    };


    onClick = () => {
        if (!this.state.loaded) {
            this.fetch();
        }
        this.setState({ showTranscripts: !this.state.showTranscripts });
    };


    onHide = () => {
        this.setState({ showTranscripts: false });
    };

    closeToast = () => {
        this.setState({ showToast: false });
    };

    addLogMessage = (message) => {
        let messages = [ ...this.state.logMessages ];
        messages.unshift(message);
        this.setState({ logMessages: messages });
    };

    render() {
        return <>
            {/* <Button */}
            {/*     // style={{ */}
            {/*     //     position: 'fixed', */}
            {/*     //     bottom: '0px', */}
            {/*     //     left: '0px', */}
            {/*     //     zIndex: 25 */}
            {/*     // }} */}
            {/*     style={{ width: '100%' }} */}
            {/*     onClick={this.onClick} */}
            {/*     variant={'honored'} */}
            {/* > */}
            {/*     Transcripts */}
            {/* </Button> */}
            <TranscriptsModal hide={this.onHide}
                              {...this.props}
                              logMessages={this.state.logMessages}
                              transcripts={this.state.transcripts}
                              userId={this.state.userId}
                              showTranscripts={this.state.showTranscripts}
                              loaded={this.state.loaded}
                              loading={this.state.loading}
            />
            {this.state.showToast &&
                <ToastEntry
                    showToast={this.state.showToast}
                    closeToast={this.closeToast}
                    transcript={this.state.packageTranscript}
                />
            }
        </>;
    }


}


export class TranscriptsButton extends Component {
    onClick = () => {
        if (this.props.app.gameController &&
            this.props.app.gameController.transcripts) {
            this.props.app.gameController.transcripts.onClick();
        }
    };

    render() {

        let showTranscriptsButton = Boolean(this.props.app.gameController &&
            this.props.app.gameController.transcripts);

        if (!showTranscriptsButton) return <></>

        return <>
            <Button
                style={{ width: '100%' }}
                onClick={this.onClick}
                variant={'honored'}
            >
                Transcripts
            </Button>
        </>;
    }


}
